<template>
  <b-container fluid>
    <b-row class="my-3">
      <b-col cols="auto">
        <b-button variant="success" @click="$emit('change-section', 'create')"
          >สร้างชุดตรวจ</b-button
        >
      </b-col>
      <b-col cols="auto">
        <b-button variant="primary" @click="exportSetTestHandler"
          >Export</b-button
        >
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-table :fields="fields" :items="getSetTest">
          <template slot="no" slot-scope="data">{{ data.index + 1 }}</template>
          <template slot="name" slot-scope="data">
            <div class="text-left">{{ data.item.name }}</div>
          </template>
          <template slot="detail" slot-scope="data" class="text-left">
            <div class="text-left">
              {{
                data.item.set_test_detail
                  .map((test) => test.test_name)
                  .join(", ")
              }}
            </div>
          </template>
          <template slot="priceCanine" slot-scope="data">
            <div class="text-right">
              {{
                data.item.prices
                  ? data.item.prices.find((price) => price.price_group_id === 2)
                    ? data.item.prices.find(
                        (price) => price.price_group_id === 2
                      ).price
                    : "- "
                  : "-"
              }}
            </div>
          </template>
          <template slot="priceMammal" slot-scope="data">
            <div class="text-right">
              {{
                data.item.prices
                  ? data.item.prices.find((price) => price.price_group_id === 3)
                    ? data.item.prices.find(
                        (price) => price.price_group_id === 3
                      ).price
                    : "- "
                  : "-"
              }}
            </div>
          </template>
          <template slot="priceLiveStock" slot-scope="data">
            <div class="text-right">
              {{
                data.item.prices
                  ? data.item.prices.find((price) => price.price_group_id === 4)
                    ? data.item.prices.find(
                        (price) => price.price_group_id === 4
                      ).price
                    : "- "
                  : "-"
              }}
            </div>
          </template>
          <template slot="actions" slot-scope="data">
            <b-row>
              <b-col cols="auto">
                <b-button
                  variant="warning"
                  @click="$emit('change-edit', data.item.id)"
                  >แก้ไขข้อมูล</b-button
                >
              </b-col>
              <b-col cols="auto">
                <b-button
                  variant="primary"
                  @click="$emit('change-price', data.item.id)"
                  >แก้ไขราคา</b-button
                >
              </b-col>
              <b-col cols="auto">
                <b-button
                  variant="danger"
                  @click="deleteSetTestHandler(data.item.id)"
                  >ลบ</b-button
                >
              </b-col>
            </b-row>
          </template>
        </b-table>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import printJS from "print-js";

export default {
  name: "SetTestTable",
  data() {
    return {
      fields: [
        {
          name: "NO",
          key: "no",
        },
        {
          name: "ชื่อ Set Test",
          key: "name",
        },
        {
          name: "ราคา canine/feline",
          key: "priceCanine",
        },
        {
          name: "ราคา exotic mammal",
          key: "priceMammal",
        },
        {
          name: "ราคา live stock",
          key: "priceLiveStock",
        },
        {
          name: "รายละเอียด",
          key: "detail",
        },
        {
          name: "ACTIONS",
          key: "actions",
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      getSetTest: "Test/getSetTest",
    }),
  },
  async created() {},
  async mounted() {
    await this.setSetTest();
  },
  methods: {
    ...mapActions({
      exportSetTest: "Settings/exportSetTest",
      setSetTest: "Test/setSetTest",
    }),
    async deleteSetTestHandler(id) {
      const { value: password } = await this.$swal.fire({
        title: "กรอกรหัสผ่านเพื่อดำเนินการต่อไป",
        input: "password",
        inputAttributes: {
          autocapitalize: "off",
          autocorrect: "off",
        },
      });

      if (password) {
        this.$emit("delete", { id, password });
      } else {
        return;
      }
    },
    async exportSetTestHandler() {
      this.$store.state.isLoading = true;
      let res;
      try {
        res = await this.exportSetTest();
      } catch (err) {
        this.$store.state.isLoading = false;
        return;
      }
      this.$store.state.isLoading = false;
      if (res.pdf_file) {
        printJS({
          printable: res.pdf_file,
          type: "pdf",
          showModal: true,
          base64: true,
        });
      }
    },
  },
};
</script>

<style scoped></style>
